import styled from 'styled-components';
import { pxToRem, unit, padding, marginBottom } from '../v2/foundation/spacing/utils.js';
import { themeGet, themeGetColor } from '../v2/foundation/theme/themeGet/get.js';
import { fontSize } from '../theme/typography/fontSize.js';
import { fontWeight } from '../theme/typography/fontWeight.js';

var spacingFromSize = function spacingFromSize(size) {
  switch (size) {
    case 'small':
      return 4;
    case 'large':
      return 25;
    case 'medium':
    default:
      return 10;
  }
};
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-mxy3c2-0"
})(["position:absolute;top:0;left:0;width:", ";height:", ";min-height:min-content;opacity:0;overflow:hidden;border:", " dashed ", ";border-radius:", ";text-align:center;background-color:", ";pointer-events:none;", ""], pxToRem(1), pxToRem(1), unit(0.5), themeGet('colors.blue.500'), themeGet('borderRadius.sm'), themeGetColor('blue.50', 0.7), function (props) {
  return props.$isDragging && "\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n    overflow: visible;\n    pointer-events: all;\n    transition: opacity 0.1s ease-in-out;\n    z-index: 1;\n  ";
});
var StickyContent = styled.div.withConfig({
  displayName: "StickyContent",
  componentId: "sc-mxy3c2-1"
})(["position:sticky;top:0;", ""], function (props) {
  return padding(spacingFromSize(props.$size), 4);
});
var Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-mxy3c2-2"
})(["position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;width:100%;height:100%;opacity:0;-webkit-appareance:none;"]);
var BadgeContainer = styled.div.withConfig({
  displayName: "BadgeContainer",
  componentId: "sc-mxy3c2-3"
})(["position:relative;display:inline-block;padding:", ";", ";border-radius:", ";&:last-child{margin-bottom:0;}"], unit(1), marginBottom(3.75), unit(5));
var Label = styled.label.withConfig({
  displayName: "Label",
  componentId: "sc-mxy3c2-4"
})(["display:block;margin-right:auto;", ";margin-left:auto;color:", ";", ";font-style:normal;", ";&:last-child{margin-bottom:0;}"], marginBottom(0.5), themeGet('colors.gray.800'), fontSize('base', 1.5), fontWeight('semibold'));
var Description = styled.p.withConfig({
  displayName: "Description",
  componentId: "sc-mxy3c2-5"
})(["max-width:", ";margin:auto;opacity:", ";", ";"], unit(100), function (props) {
  return props.$hide ? 0 : 1;
}, fontSize('base', 1.65));

export { BadgeContainer, Container, Description, Input, Label, StickyContent };
